// import React from "react";
// import { Navigate } from "react-router-dom";
// import UserService from "service/UserSerivce";
// import { clearLocalStorage } from "utils/storage";
import PropTypes from "prop-types";
import { jwtDecode } from "jwt-decode";

export default function ProtectedRoute({ children }) {
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      localStorage.removeItem("user");
      localStorage.removeItem("refreshToken");
    }
    if (token) {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      if (decoded.exp < currentTime) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("refreshToken");
      }
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
  }

  return children;
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  permissionCode: PropTypes.string,
};
ProtectedRoute.defaultProps = {
  permissionCode: "NOT_REQUIRED",
};
